export const BROWSING_MODES = [
    "random",
    "newest",
    "oldest",
    "best",
    "controversial",
    "recommended",
    "untagged",
    "ai_analyzed",
] as const;

export type BrowsingMode = (typeof BROWSING_MODES)[number];

export const BROWSING_MODE_LABELS: Record<BrowsingMode, string> = {
    random: "Random",
    newest: "Newest First",
    oldest: "Oldest First",
    best: "Best",
    controversial: "Controversial",
    recommended: "For You",
    untagged: "Untagged",
    ai_analyzed: "AI Analyzed",
};

// outer parens required: parser rejects `a AND NOT (b)` without the wrap
// because `AND NOT` is a chained operator pair that needs an explicit group.
export const UNTAGGED_TAG_QUERY =
    "(new AND NOT (good OR funny OR meh OR r OR reaction_image))";

export const SEARCH_MODES = ["natural", "exact", "fuzzy", "fts"] as const;

export type SearchModeLabel = (typeof SEARCH_MODES)[number];

export const SEARCH_MODE_LABELS: Record<SearchModeLabel, string> = {
    natural: "Smart",
    exact: "Exact",
    fuzzy: "Fuzzy",
    fts: "Full-Text",
};

export const SEARCH_MODE_DESCRIPTIONS: Record<SearchModeLabel, string> = {
    natural: "Uses synonyms and AI-detected content types",
    exact: "Matches keywords exactly as typed",
    fuzzy: "Tolerates typos and variations",
    fts: "Porter-stemmed search across OCR text, descriptions, and tags",
};
